import { render, staticRenderFns } from "./advantageView.vue?vue&type=template&id=5fe61cd5&scoped=true"
import script from "./advantageView.vue?vue&type=script&lang=js"
export * from "./advantageView.vue?vue&type=script&lang=js"
import style0 from "./advantageView.vue?vue&type=style&index=0&id=5fe61cd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe61cd5",
  null
  
)

export default component.exports